<template>
  <section class="section container">
    <div class="title is-3 has-text-centered">{{ $t("whatsapp") }}</div>
    <div class="grid is-col-min-10">
      <div class="cell" @click="messages">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn3.iconfinder.com/data/icons/social-media-2034/500/whatsapp-512.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("messages") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cell" @click="chatbot">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/1698/1698535.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("chatbots") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { warning_message, get } from "@/utils";

export default {
  name: "WhatsappIndex",
  components: {},
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    messages() {
      let v = this;
      v.$router.push({
        path: "/whatsapp/message",
      });
    },
    chatbot() {
      let v = this;
      v.$router.push({
        path: "/whatsapp/chatbot",
      });
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped>
.grid .cell .card:hover {
  border-radius: 0.5em;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: linear 0.1s;
  transform: scale(1.05, 1.05);
}
.grid .cell .card:active {
  border-radius: 20px;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: ease-out 0.3s;
  transform: scale(1.5, 1.5);
  opacity: 0;
}

.grid .cell .card {
  background-color: rgba(20, 22, 26, 0.4);
}
</style>
